import { NormalText } from '@Src/commons/StyledComponent';
import { Row } from 'antd';
import React from 'react';
import COLOR from '@Src/commons/Colors';

type ErrorType = {
  title: string;
  message: string;
};

type InvoiceExpiredType = {
  error: ErrorType;
};

export default function InvoiceExpired({ error }: InvoiceExpiredType) {
  return (
    <div className="align-items-center flex-column-direction invoice-expired pt-16 pl-24 pr-24 h-gap-24 ">
      <Row>
        <div className="error-cat-logo" />
      </Row>
      <Row className="screen-width w-100" justify="center">
        <NormalText color={COLOR.RED_2} fontSize={20} fontWeight={400}>
          {error.title}
        </NormalText>
      </Row>
      <Row className="screen-width w-100" justify="center">
        <NormalText
          color={COLOR.GREY_8}
          fontSize={14}
          fontWeight={400}
          textAlign="center"
        >
          {error.message}
        </NormalText>
      </Row>
    </div>
  );
}
